import { render, staticRenderFns } from "./formilyTodoForm-new.vue?vue&type=template&id=073e7a85&scoped=true"
import script from "./formilyTodoForm-new.vue?vue&type=script&lang=js"
export * from "./formilyTodoForm-new.vue?vue&type=script&lang=js"
import style0 from "./formilyTodoForm-new.vue?vue&type=style&index=0&id=073e7a85&prod&scoped=true&lang=less"
import style1 from "./formilyTodoForm-new.vue?vue&type=style&index=1&id=073e7a85&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e7a85",
  null
  
)

export default component.exports